import React from 'react';
import { useSelector } from 'react-redux';

const statuses = ['ACCEPTED', 'CASHED_OUT', 'RETURNED', 'LOST', 'WON'];

const useStatusItems = () => {
  const locale = useSelector(state => state.locale.locale.sportHistory);

  const items = statuses.map(v => ({
    value: v,
    key: v,
    renderElement: locale.status?.[v] ?? v,
    selectedRenderElement: locale.status?.[v] ?? v,
    active: false,
  }));

  return [
    {
      value: 'all',
      key: 'all',
      renderElement: locale.all,
      selectedRenderElement: locale.all,
      active: true,
    },
  ].concat(items);
};

export default useStatusItems;
